import { render, staticRenderFns } from "./reports_tab_count.vue?vue&type=template&id=1970c273"
import script from "./reports_tab_count.vue?vue&type=script&lang=js"
export * from "./reports_tab_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports